import { ActionIcon } from '@mantine/core';
import Button from '../Button/Button';
import IconButton from '../IconButton/IconButton';
import { buttons } from './TopBarEditor.data';
import { filter } from './TopBarEditor.utils';

export function NextPrevArrows(props: any) {
  const { data, callbacks } = props;
  const { nextPrevModels } = data;

  return (
    <ActionIcon.Group>
      <IconButton
        name='IconArrowLeft'
        onClick={() => callbacks.onAction({ type: 'EDITOR', verb: 'prevModel' })}
        disabled={!nextPrevModels.prevExists}
      />
      <IconButton
        name='IconArrowRight'
        onClick={() => callbacks.onAction({ type: 'EDITOR', verb: 'nextModel' })}
        disabled={!nextPrevModels.prevExists}
      />
    </ActionIcon.Group>
  );
}

export function ButtonGroup(props: any) {
  const { pos, callbacks, color = 'pink', data } = props;
  const { user, isPlayground } = data;
  const { isPayingCustomer, isEmployee } = user;

  function renderButton(button: Json) {
    const { iconName, title, action } = button;

    if (iconName) {
      return (
        <IconButton
          key={iconName}
          color={color}
          size={20}
          name={iconName}
          onClick={() => callbacks.onAction(action)}
        />
      );
    } else {
      return (
        <Button
          color={color}
          variant='subtle'
          size='xs'
          onClick={() => callbacks.onAction(action)}
          key={title}
        >
          {title}
        </Button>
      );
    }
  }

  function renderButtons(pos: string) {
    return buttons[pos]
      .filter((link: Json) => filter(link, isPlayground, isPayingCustomer, isEmployee))
      .map((button: Json) => renderButton(button));
  }

  return <>{renderButtons(pos)}</>;
}
